export class JsonDocument{
  constructor(name: string, value: any) {
    this[name] = value;
  }
}